// extracted by mini-css-extract-plugin
module.exports = {"partnerLayout":"PartnerLayout_partnerLayout__31T2K"};